"use client";
import Footer from "@/components/shared/Footer";
import Header from "@/components/shared/Header";
import React, { useEffect, useState } from "react";
import cap from "@/public/images/cap.svg";
import Image from "next/image";
import lecture from "@/public/images/lecture.svg";
import exam from "@/public/images/exam.svg";
import Tabs from "./Tabs";
import { useAppDispatch, useAppSelector } from "@/redux/store";
import USER, { SelectSingleTeacher } from "@/redux/User";
import Link from "next/link";
import facebook from "@/public/images/FacebookW.svg";
import telegramW from "@/public/images/telegramW.svg";
import whatsApp from "@/public/images/whatsAppW.svg";
import Loader from "@/components/shared/Loader";
import ErrorMessage from "@/components/shared/ErrorMessage";
import defaultImage from "@/public/images/default_image.jpg";
import MyLink from "@/components/shared/myLink/MyLink";
import ShareComponent from "@/components/shared/ShareComponent";
import SubscribeWithTeacher from "@/components/shared/SubscribeWithTeacher";
// import { Metadata } from "next";

// export const metadata: Metadata = {
//   title: "المشرف",
// };
const page = ({ params }: { params: { id: string } }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const dispatch = useAppDispatch();
  const teacher = useAppSelector(SelectSingleTeacher);

  useEffect(() => {
    dispatch(USER.thunks.doGetSingleTeachers({ id: params.id }))
      .then((res: any) => {
        if (res.error && res.error.message) {
          setError(res.payload.message);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [params, dispatch]);
  if (isLoading) {
    return <Loader />;
  }

  if (error) {
    return <ErrorMessage message={error} />;
  }

  if (!params || !params.id || !teacher) {
    return <ErrorMessage message={"يوجد خطأ حاول مره اخري."} />;
  }

  const hasLinks =
    teacher?.facebook_group_link ||
    teacher?.telegram_channel ||
    teacher?.whatsapp_number;

  return (
    <>
      <Header />
      <div className=" container my-5">
        <div className=" p-[20px] rounded-[20px] bg-[#5F4D46]">
          <div className="flex flex-col md:flex-row gap-5 w-full">
            <div className="w-full md:w-[333px] min-h-[200px] h-[333px] relative">
              <Image
                src={teacher.image || defaultImage}
                alt="instructor"
                fill
                sizes="100vw"
                className=" rounded-[10px] object-cover object-top"
              />
            </div>

            <div className=" flex flex-col gap-3">
              <div className=" flex items-center gap-3">
                <Image
                  src={cap}
                  alt="cap"
                />
                <p className=" text-16 text-white">{teacher?.subject?.name}</p>
              </div>
              <p className=" text-[25px] text-white font-[700]">
                {teacher?.name}
              </p>
              <p className=" txt-16 text-textColor max-w-[1050px]">
                {teacher?.description}
              </p>
              <div className=" flex items-center flex-wrap gap-5 mt-3">
                {teacher?.school_years?.map((item: any, index: number) => (
                  <p
                    key={index}
                    className=" text-14 text-textColor py-[5px] px-[15px] bg-[#695750] rounded-[10px] w-fit"
                  >
                    {item.name}
                  </p>
                ))}
              </div>
              {hasLinks && (
                <>
                  <p className="text-16 text-textColor mb-2">
                    لينكات وسائل التواصل الخاصة بالمدرس
                  </p>
                  <div className="flex items-center gap-3">
                    {teacher?.facebook_group_link && (
                      <MyLink
                        href={teacher.facebook_group_link}
                        className="bg-[#515457] w-[48px] h-[48px] rounded-[10px] flex items-center justify-center"
                        target="_blank"
                      >
                        <Image
                          src={facebook}
                          alt="facebook"
                        />
                      </MyLink>
                    )}
                    {teacher?.telegram_channel && (
                      <MyLink
                        href={teacher.telegram_channel}
                        className="bg-[#515457] w-[48px] h-[48px] rounded-[10px] flex items-center justify-center"
                        target="_blank"
                      >
                        <Image
                          src={telegramW}
                          alt="telegram"
                        />
                      </MyLink>
                    )}
                    {teacher?.whatsapp_number && (
                      <MyLink
                        href={`https://wa.me/${teacher.whatsapp_number}`}
                        className="bg-[#515457] w-[48px] h-[48px] rounded-[10px] flex items-center justify-center"
                        target="_blank"
                      >
                        <Image
                          src={whatsApp}
                          alt="whatsApp"
                        />
                      </MyLink>
                    )}
                  </div>
                </>
              )}
              <SubscribeWithTeacher teacher={teacher} />
              <ShareComponent title={teacher.name} />
            </div>
          </div>

          <div className=" bg-[#695750] rounded-[10px] w-fit flex items-center justify-between gap-3 md:gap-10 py-3 px-7 mt-10">
            {/* <div className=" flex flex-col items-center justify-center grow  ">
              <Image src={bookIcon} alt="time" />
              <p className=" text-16 text-textColor font-[500] text-center">
                +10 كتاب
              </p>
            </div> */}
            <div className=" px-10 flex flex-col items-center justify-center grow border-l border-[#6F7275]">
              <Image
                src={lecture}
                alt="time"
              />
              <p className=" text-16 text-textColor font-[500] text-center ">
                {teacher?.courses?.length} كورس
              </p>
            </div>
            <div className=" flex flex-col items-center justify-center grow">
              <Image
                src={exam}
                alt="time"
              />
              <p className=" text-16 text-textColor font-[500] text-center ">
                {" "}
                {teacher?.full_exams?.length} اختبارات شاملة
              </p>
            </div>
          </div>
        </div>
      </div>
      <Tabs teacher={teacher} />
      <Footer />
    </>
  );
};

export default page;
